(function () {
  function parseBands(filterEl) {
    const raw = filterEl.dataset.availableBands || '';
    return raw
      .split(',')
      .map(function (value) {
        return parseInt(value, 10);
      })
      .filter(function (value) {
        return !Number.isNaN(value);
      })
      .sort(function (a, b) {
        return a - b;
      });
  }

  function snapUpToStep(value, step) {
    return Math.ceil(value / step) * step;
  }

  function snapDownToStep(value, step) {
    return Math.floor(value / step) * step;
  }

  function initBandFilter(filterEl) {
    const bands = parseBands(filterEl);
    const paramName = filterEl.dataset.paramName;
    const step = parseInt(filterEl.dataset.step, 10) || 50;
    const stateMinParam = filterEl.dataset.stateMinParam;
    const stateMaxParam = filterEl.dataset.stateMaxParam;

    if (!bands.length || !paramName) return;

    const minBand = bands[0];
    const maxBand = bands[bands.length - 1];

    const minNumberInput = filterEl.querySelector('[data-sales-unit-band-number="min"]');
    const maxNumberInput = filterEl.querySelector('[data-sales-unit-band-number="max"]');
    const minRangeInput = filterEl.querySelector('[data-sales-unit-band-range="min"]');
    const maxRangeInput = filterEl.querySelector('[data-sales-unit-band-range="max"]');
    const trackFill = filterEl.querySelector('[data-sales-unit-band-track-fill]');

    if (!minNumberInput || !maxNumberInput || !minRangeInput || !maxRangeInput || !trackFill) {
      return;
    }

    var currentMin = parseInt(filterEl.dataset.activeMin, 10);
    var currentMax = parseInt(filterEl.dataset.activeMax, 10);
    var url = new URL(window.location.href);

    if (stateMinParam) {
      var urlMin = parseInt(url.searchParams.get(stateMinParam), 10);
      if (!Number.isNaN(urlMin)) currentMin = urlMin;
    }
    if (stateMaxParam) {
      var urlMax = parseInt(url.searchParams.get(stateMaxParam), 10);
      if (!Number.isNaN(urlMax)) currentMax = urlMax;
    }

    if (Number.isNaN(currentMin)) currentMin = minBand;
    if (Number.isNaN(currentMax)) currentMax = maxBand;

    function normalizeValues(minValue, maxValue, source) {
      var snappedMin = snapUpToStep(minValue, step);
      var snappedMax = snapDownToStep(maxValue, step);

      if (snappedMin > snappedMax) {
        if (source === 'min') {
          snappedMax = snappedMin;
        } else {
          snappedMin = snappedMax;
        }
      }

      return {
        min: Math.max(minBand, Math.min(snappedMin, maxBand)),
        max: Math.max(minBand, Math.min(snappedMax, maxBand)),
      };
    }

    function updateUi() {
      minNumberInput.value = String(currentMin);
      maxNumberInput.value = String(currentMax);
      minRangeInput.value = String(currentMin);
      maxRangeInput.value = String(currentMax);

      var leftPercent = ((currentMin - minBand) / Math.max(maxBand - minBand, 1)) * 100;
      var rightPercent = ((currentMax - minBand) / Math.max(maxBand - minBand, 1)) * 100;

      trackFill.style.left = leftPercent + '%';
      trackFill.style.right = 100 - rightPercent + '%';
    }

    function submitFilter() {
      var submitUrl = new URL(window.location.href);
      var params = submitUrl.searchParams;

      params.delete(paramName);
      params.delete('page');
      if (stateMinParam) params.delete(stateMinParam);
      if (stateMaxParam) params.delete(stateMaxParam);

      var selectedBands = bands.filter(function (bandValue) {
        return bandValue >= currentMin && bandValue <= currentMax;
      });

      if (selectedBands.length !== bands.length) {
        selectedBands.forEach(function (bandValue) {
          params.append(paramName, String(bandValue));
        });
        if (stateMinParam) params.set(stateMinParam, String(currentMin));
        if (stateMaxParam) params.set(stateMaxParam, String(currentMax));
      }

      var search = params.toString();
      window.location.search = search ? '?' + search : '';
    }

    function setValues(minValue, maxValue, source, shouldSubmit) {
      if (Number.isNaN(minValue)) minValue = currentMin;
      if (Number.isNaN(maxValue)) maxValue = currentMax;

      var normalized = normalizeValues(minValue, maxValue, source);
      currentMin = normalized.min;
      currentMax = normalized.max;
      updateUi();

      if (shouldSubmit) {
        submitFilter();
      }
    }

    minRangeInput.addEventListener('input', function (event) {
      setValues(parseInt(event.target.value, 10), currentMax, 'min', false);
    });

    maxRangeInput.addEventListener('input', function (event) {
      setValues(currentMin, parseInt(event.target.value, 10), 'max', false);
    });

    minRangeInput.addEventListener('change', function (event) {
      setValues(parseInt(event.target.value, 10), currentMax, 'min', true);
    });

    maxRangeInput.addEventListener('change', function (event) {
      setValues(currentMin, parseInt(event.target.value, 10), 'max', true);
    });

    minNumberInput.addEventListener('change', function (event) {
      setValues(parseInt(event.target.value, 10), currentMax, 'min', true);
    });

    maxNumberInput.addEventListener('change', function (event) {
      setValues(currentMin, parseInt(event.target.value, 10), 'max', true);
    });

    setValues(currentMin, currentMax, 'min', false);
  }

  function init() {
    document.querySelectorAll('[data-sales-unit-band-filter]').forEach(initBandFilter);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
